'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Field } from '../Field/index.js';
import { Input } from '../Input/Input.js';
import { Label } from '../Label/Label.js';
import { ValidationMessage } from '../ValidationMessage/ValidationMessage.js';

/**
 * Radio used to select multiple options.
 *
 * @example
 * <Radio label="I agree" value="agree" />
 */
const Radio = forwardRef(function Radio({ 'data-size': size, className, style, children, label, description, error, ...rest }, ref) {
    return (jsxs(Field, { "data-size": size, className: className, style: style, children: [jsx(Input, { type: 'radio', ref: ref, ...rest }), !!label && jsx(Label, { weight: 'regular', children: label }), !!description && jsx("div", { "data-field": 'description', children: description }), !!error && jsx(ValidationMessage, { children: error })] }));
});

export { Radio };
